/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-application.html";

import "@nuskin/ns-style-elements";

/**
 * A Nuskin Application.
 * <br>
 * <section>
 *  <h2>Content Guidelines2</h2>
 *  <p>Here are some guidelines.</p>
 * </section>
 *
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-application country="FR"></ns-application>
 *   </template>
 * </demo-snippet>
 *
 *
 */
export class NsApplication extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-application";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      country: {
        type: String
      }
    };
  }

  ready() {
    super.ready();
    console.log("Inited ns-application");
  }
}
customElements.define(NsApplication.is, NsApplication);
